import { render } from "./removebutton.vue?vue&type=template&id=e99ddbb2&scoped=true"
import script from "./removebutton.vue?vue&type=script&lang=js"
export * from "./removebutton.vue?vue&type=script&lang=js"

import "./removebutton.vue?vue&type=style&index=0&id=e99ddbb2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99ddbb2"]])

export default __exports__